exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning {\r\n    font-size: 18px;\r\n    text-align: center;\r\n    padding-top: 50px;\r\n}\r\n\r\n.usc_nav_bar {\r\n    background-color: black;\r\n    height: 33px;\r\n    color: white;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-waiting/usc-p2w-waiting.component.css
// module id = ../../../../../src/app/components/usc-store/usc-p2w-waiting/usc-p2w-waiting.component.css
// module chunks = main